import { NextLink, Operation } from '@apollo/client';

import { staticLDContextUserAttrs } from 'state/launchdarkly/launchdarkly-core';

import { Header } from '../headers';

/**
 * Adds the LaunchDarkly context to the request headers
 * if the `withLDContext` flag is set in the operation context.
 * @param operation
 * @param forward
 * @returns
 */
export const withLDFlagsHeader = (operation: Operation, forward: NextLink) => {
  // Check for withLDContext flag in operation context
  const { withLDContext, ...restContext } = operation.getContext();
  if (withLDContext) {
    operation.setContext({
      headers: {
        [Header.LD_CONTEXT]: staticLDContextUserAttrs.current
          ? JSON.stringify(staticLDContextUserAttrs.current)
          : '',
      },
      ...restContext,
    });
  }
  return forward(operation);
};
